if (!customElements.get("social-gallery-slider")) {
  class SocialGallerySlider extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;

      this.handleMouseEnter =
        this.handleMouseEnter.bind(this);

      this.handleMouseLeave =
        this.handleMouseLeave.bind(this);
    }

    connectedCallback() {
      if (this.swiper) return;

      this.slider = this.querySelector(
        "[data-social-gallery-swiper]"
      );

      if (!this.slider) return;

      this.prevButton = this.querySelector(
        "[data-social-gallery-prev]"
      );

      this.nextButton = this.querySelector(
        "[data-social-gallery-next]"
      );

      this.pagination = this.querySelector(
        "[data-social-gallery-pagination]"
      );

      this.pauseOnHover =
        this.dataset.pauseOnHover === "true";

      this.initSlider();

      if (this.pauseOnHover) {
        this.addEventListener(
          "mouseenter",
          this.handleMouseEnter
        );

        this.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        );
      }
    }

    initSlider() {
      if (typeof window.Swiper !== "function") {
        window.setTimeout(() => {
          this.initSlider();
        }, 100);

        return;
      }

      const slidesDesktop =
        Number(this.dataset.slidesDesktop) || 5;

      const slidesTablet =
        Number(this.dataset.slidesTablet) || 3;

      const slidesMobile =
        Number(this.dataset.slidesMobile) || 1.35;

      const gapDesktop =
        Number(this.dataset.gapDesktop) || 12;

      const gapMobile =
        Number(this.dataset.gapMobile) || 20;

      const speed =
        Number(this.dataset.speed) || 500;

      const enableLoop =
        this.dataset.loop === "true";

      const enableDrag =
        this.dataset.drag === "true";

      const autoRotate =
        this.dataset.autoRotate === "true";

      const autoRotateDelay =
        Number(this.dataset.autoRotateDelay) || 4000;

      const options = {
        slidesPerView: slidesMobile,
        spaceBetween: gapMobile,
        speed: speed,

        loop: enableLoop,

        grabCursor: enableDrag,
        allowTouchMove: enableDrag,
        simulateTouch: enableDrag,

        watchOverflow: true,

        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        resizeObserver: true,

        navigation:
          this.prevButton && this.nextButton
            ? {
                prevEl: this.prevButton,
                nextEl: this.nextButton
              }
            : false,

        pagination:
          this.pagination
            ? {
                el: this.pagination,
                clickable: true
              }
            : false,

        breakpoints: {
          750: {
            slidesPerView: slidesTablet,
            spaceBetween: gapDesktop
          },

          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop
          }
        }
      };

      if (autoRotate) {
        options.autoplay = {
          delay: autoRotateDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        };
      }

      this.swiper = new window.Swiper(
        this.slider,
        options
      );
    }

    handleMouseEnter() {
      if (
        this.swiper &&
        this.swiper.autoplay &&
        this.swiper.autoplay.running
      ) {
        this.swiper.autoplay.pause();
      }
    }

    handleMouseLeave() {
      if (
        this.swiper &&
        this.swiper.autoplay
      ) {
        this.swiper.autoplay.resume();
      }
    }

    disconnectedCallback() {
      this.removeEventListener(
        "mouseenter",
        this.handleMouseEnter
      );

      this.removeEventListener(
        "mouseleave",
        this.handleMouseLeave
      );

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define(
    "social-gallery-slider",
    SocialGallerySlider
  );
}